import { render, staticRenderFns } from "./CascaderDataManage.vue?vue&type=template&id=dddb1690"
import script from "./CascaderDataManage.vue?vue&type=script&lang=js"
export * from "./CascaderDataManage.vue?vue&type=script&lang=js"
import style0 from "./CascaderDataManage.vue?vue&type=style&index=0&id=dddb1690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports